










import { Component, Vue } from "vue-property-decorator";
// import { Action, Getter, Mutation } from "vuex-class";
import MemberForm from "@/components/sale/forms/MemberForm.vue";

@Component({
  components: { MemberForm },
})
export default class extends Vue {}
